var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import styled from 'styled-components';
import { Spinner } from '../Spinner';
var ArcPassportImage = styled.img(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: ", "px;\n  ", "\n"], ["\n  width: ", "px;\n  ", "\n"])), function (p) { return (p.size ? p.size : '300'); }, function (p) { return (!p.loaded ? 'display: none;' : ''); });
var Placeholder = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  width: ", "px;\n  height: ", "px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n"], ["\n  width: ", "px;\n  height: ", "px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n"])), function (p) { return p.size || 300; }, function (p) { return (p.size ? p.size * 1.4666 : 300 * 1.466); });
export var ArcPassportCard = function (_a) {
    var _b = _a.src, src = _b === void 0 ? 'https://staging.api.arcx.money/skins/image/arcx/purple?glow=false' : _b, _c = _a.size, size = _c === void 0 ? 175 : _c;
    var _d = useState(false), loaded = _d[0], setLoaded = _d[1];
    var onLoad = function () {
        setLoaded(true);
    };
    return (_jsxs(_Fragment, { children: [!loaded && (_jsx(Placeholder, __assign({ size: size }, { children: _jsx(Spinner, {}, void 0) }), void 0)), _jsx(ArcPassportImage, { loaded: loaded, size: size, src: src, onLoad: onLoad }, void 0)] }, void 0));
};
var templateObject_1, templateObject_2;
//# sourceMappingURL=ArcPassportCard.js.map